var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5615 3.60719C15.757 3.8027 15.757 4.11968 15.5615 4.31519L14.5173 5.3594L12.5148 3.35686L13.559 2.31265C13.7545 2.11714 14.0715 2.11714 14.267 2.31265L15.5615 3.60719Z",
    fill: "#2362A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8093 6.06741L11.8068 4.06486L4.98512 10.8865C4.93016 10.9415 4.88876 11.0085 4.86418 11.0822L4.0586 13.499C3.99337 13.6946 4.17954 13.8808 4.37523 13.8156L6.79198 13.01C6.86571 12.9854 6.93271 12.944 6.98766 12.8891L13.8093 6.06741Z",
    fill: "#2362A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0415 15.1825C1.0415 16.012 1.71393 16.6845 2.54341 16.6845H13.5574C14.3869 16.6845 15.0593 16.012 15.0593 15.1825V9.17492C15.0593 8.89842 14.8352 8.67428 14.5587 8.67428C14.2822 8.67428 14.058 8.89842 14.058 9.17492V15.1825C14.058 15.459 13.8339 15.6832 13.5574 15.6832H2.54341C2.26692 15.6832 2.04278 15.459 2.04278 15.1825V4.16856C2.04278 3.89207 2.26692 3.66792 2.54341 3.66792H9.05168C9.32817 3.66792 9.55231 3.44378 9.55231 3.16729C9.55231 2.89079 9.32817 2.66665 9.05168 2.66665H2.54341C1.71393 2.66665 1.0415 3.33908 1.0415 4.16856V15.1825Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChange);
export default __webpack_public_path__ + "static/media/icon_change.75da608e90c76caca805e7a7aa1309ba.svg";
export { ForwardRef as ReactComponent };